// 7 pillars × 5 questions = 35 questions
export const PILLARS = [
  {
    id: "lideranca",
    name: "Liderança",
    description:
      "Como líderes desenvolvem pessoas, tomam decisões e conduzem a equipe.",
    questions: [
      "Os líderes desenvolvem pessoas continuamente.",
      "Os líderes realizam feedbacks frequentes.",
      "Existe clareza nas responsabilidades.",
      "As decisões são tomadas com rapidez.",
      "A equipe confia na liderança.",
    ],
  },
  {
    id: "comunicacao",
    name: "Comunicação",
    description:
      "Fluidez, clareza e velocidade com que a informação circula na empresa.",
    questions: [
      "Existe comunicação clara.",
      "As informações chegam corretamente.",
      "Existem reuniões produtivas.",
      "Os conflitos são tratados rapidamente.",
      "As expectativas são claras.",
    ],
  },
  {
    id: "desenvolvimento_humano",
    name: "Desenvolvimento Humano",
    description:
      "Como a empresa forma, evolui e retém seus talentos ao longo do tempo.",
    questions: [
      "Existe treinamento contínuo.",
      "Os colaboradores evoluem.",
      "Existe plano de desenvolvimento.",
      "A empresa incentiva aprendizado.",
      "Os líderes desenvolvem talentos.",
    ],
  },
  {
    id: "gestao",
    name: "Gestão",
    description:
      "Estrutura de indicadores, processos e rotinas de gestão do negócio.",
    questions: [
      "Existem indicadores.",
      "Os processos são claros.",
      "As metas são acompanhadas.",
      "Os problemas são tratados rapidamente.",
      "Existe rotina de gestão.",
    ],
  },
  {
    id: "cultura",
    name: "Cultura",
    description:
      "Valores vividos no dia a dia e senso de pertencimento das pessoas.",
    questions: [
      "Os valores são vividos.",
      "Existe senso de pertencimento.",
      "As pessoas trabalham em equipe.",
      "Existe responsabilidade.",
      "Há comprometimento.",
    ],
  },
  {
    id: "performance",
    name: "Performance",
    description:
      "Foco em resultados, qualidade das entregas e melhoria contínua.",
    questions: [
      "Os resultados são acompanhados.",
      "Existe melhoria contínua.",
      "Os erros geram aprendizado.",
      "As entregas possuem qualidade.",
      "Existe foco em produtividade.",
    ],
  },
  {
    id: "inovacao_crescimento",
    name: "Inovação e Crescimento",
    description:
      "Capacidade de inovar, investir e planejar o futuro do negócio.",
    questions: [
      "A empresa busca inovação.",
      "Os líderes incentivam melhorias.",
      "Existem novas ideias.",
      "A empresa investe em desenvolvimento.",
      "Existe planejamento para o futuro.",
    ],
  },
];

export const SCALE_LABELS = {
  1: "Discordo totalmente",
  2: "Discordo parcialmente",
  3: "Neutro",
  4: "Concordo parcialmente",
  5: "Concordo totalmente",
};

export const BADGES = [
  { min: 0, max: 40, name: "Empresa Emergente" },
  { min: 40, max: 60, name: "Empresa em Evolução" },
  { min: 60, max: 80, name: "Empresa Estruturada" },
  { min: 80, max: 101, name: "Empresa de Alta Performance" },
];

export const ACTIONS = {
  lideranca: [
    "Estabelecer rotinas periódicas de acompanhamento entre líderes e equipes.",
    "Definir claramente papéis, responsabilidades e níveis de decisão.",
    "Desenvolver continuamente as competências de liderança dos gestores.",
  ],
  comunicacao: [
    "Padronizar os principais fluxos de comunicação interna.",
    "Realizar reuniões periódicas com objetivos e responsáveis definidos.",
    "Garantir que metas, prioridades e resultados sejam comunicados de forma clara.",
  ],
  desenvolvimento_humano: [
    "Estruturar planos de desenvolvimento alinhados às necessidades da empresa.",
    "Padronizar os processos de integração e capacitação dos colaboradores.",
    "Criar uma rotina contínua de desenvolvimento das competências da equipe.",
  ],
  gestao: [
    "Padronizar indicadores e rotinas de acompanhamento.",
    "Definir metas claras para equipes e lideranças.",
    "Implantar ciclos regulares de análise e tomada de decisão.",
  ],
  cultura: [
    "Reforçar os valores organizacionais nas práticas do dia a dia.",
    "Reconhecer comportamentos alinhados à cultura desejada.",
    "Medir periodicamente o clima e o engajamento das equipes.",
  ],
  performance: [
    "Acompanhar indicadores-chave de desempenho com frequência.",
    "Eliminar desperdícios e gargalos operacionais identificados.",
    "Promover ciclos contínuos de melhoria dos processos.",
  ],
  inovacao_crescimento: [
    "Incentivar a geração de ideias para melhoria dos processos.",
    "Avaliar regularmente oportunidades de inovação e expansão.",
    "Transformar aprendizados em melhorias permanentes para a empresa.",
  ],
};

export const SEGMENTOS = [
  "Indústria",
  "Comércio / Varejo",
  "Serviços",
  "Tecnologia",
  "Saúde",
  "Educação",
  "Construção Civil",
  "Agronegócio",
  "Logística",
  "Financeiro",
  "Alimentação",
  "Outro",
];

export const ESTADOS = [
  "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA",
  "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN",
  "RO", "RR", "RS", "SC", "SE", "SP", "TO",
];
